class WordList {
  static instance;
  words = [];
  isLoaded = false;
  path = "/wordlist.txt";

  constructor() {
    if (!WordList.instance) {
      WordList.instance = this;
    }
    return WordList.instance;
  }

  static getInstance() {
    if (!WordList.instance) {
      WordList.instance = new WordList();
    }
    return WordList.instance;
  }

  async loadWords() {
    if (this.isLoaded) return;
    else console.log("nicht geladen");

    try {
      const response = await fetch(this.path);
      if (!response.ok)
        throw new Error(`Fehler beim Laden: ${response.statusText}`);

      const text = await response.text();
      this.words = text
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

      this.isLoaded = true;
      console.log(`Wortliste geladen: ${this.words.length} Wörter`);
      console.log(this.words);
    } catch (error) {
      console.error("Fehler beim Laden der Wortliste:", error);
    }
  }

  getRandomWord() {
    if (!this.isLoaded || this.words.length === 0) {
      throw new Error("Wortliste ist noch nicht geladen!");
    }
    const randomIndex = Math.floor(Math.random() * this.words.length);
    return this.words[randomIndex];
  }
}

export default WordList;
